<template>
  <div>
    <div
      style="
        overflow-y: scroll;
        max-height: 500px;
        border-right: green 2px solid;
      "
      class="table-responsive"
    >
      <!-------------------- Tabla de Resultados -------------------->

      <table
        v-if="dataTabla && dataTabla[0]"
        id="table"
        class="table table-hover"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Codigo Producto</th>
            <th>Tienda</th>
            <th>Usuario</th>
            <th>Fecha</th>
            <th>Cantidad</th>
            <th class="text-center">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr
            style="height: 40px"
            v-for="current in dataTabla"
            v-bind:key="current.id"
            @click="rowClick(current)"
          >
            <td>{{ current.numero }}</td>
            <td>{{ current.producto }}</td>
            <td>{{ current.tienda.nombre }}</td>
            <td>{{ current.usuario.name }}</td>
            <td>{{ current.fecha }}</td>
            <td>{{ current.cantidad }}</td>
            <td class="text-center">{{ current.estado_str }}</td>
          </tr>
        </tbody>
      </table>
      <!-------------------- END - Basic Table -------------------->
    </div>
    <br />
    <br />
    <button
      id="btnExport"
      class="btn btn-secondary btn-block btn-sm"
      @click="fnExcelReport()"
    >
      Exportar en CSV
    </button>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
      current: {
        tienda: "",
        usuario: "",
      },
    };
  },
  props: ["dataTabla"],
  mounted() {
    let self = this;
  },
  methods: {
    fnExcelReport() {
      var i, j;
      var csv = "";
      var table = document.getElementById("table");
      var table_headings = table.children[0].children[0].children;
      var table_body_rows = table.children[1].children;
      var heading;
      var headingsArray = [];
      for (i = 0; i < table_headings.length; i++) {
        heading = table_headings[i];
        headingsArray.push('"' + heading.innerHTML + '"');
      }
      csv += headingsArray.join(",") + ";\n";
      var row;
      var columns;
      var column;
      var columnsArray;
      for (i = 0; i < table_body_rows.length; i++) {
        row = table_body_rows[i];
        columns = row.children;
        columnsArray = [];
        for (j = 0; j < columns.length; j++) {
          var column = columns[j];
          columnsArray.push('"' + column.innerHTML + '"');
        }
        csv += columnsArray.join(",") + ";\n";
      }

      this.download("Conversiones.csv", csv);
    },
    download(filename, text) {
      var pom = document.createElement("a");
      pom.setAttribute(
        "href",
        "data:text/csv;charset=utf-8," + encodeURIComponent(text)
      );
      pom.setAttribute("download", filename);

      if (document.createEvent) {
        var event = document.createEvent("MouseEvents");
        event.initEvent("click", true, true);
        pom.dispatchEvent(event);
      } else {
        pom.click();
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      DynamicService.fetch("inv", "conversion-e", {
        page: page,
        "filter[search]": this.$data.searchtext,
      }).then((response) => {
        self.dataTabla = response.data.results;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-conversiones-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-conversiones-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
